import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/attachment.svg'
import _imports_1 from '@/app/ui/assets/svg/download.svg'


const _hoisted_1 = { class: "flex flex-row items-center overflow-hidden" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 mr-3",
  alt: "attachment"
}, null, -1)
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-lp-100 py-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: 
      `w-full flex flex-row gap-2 justify-between rounded-md text-12px xxl:text-14px items-center ${
        _ctx.bordered ? 'border py-4 px-4' : ''
      } ${_ctx.dash ? 'border-dashed' : ''}
      ${_ctx.error ? 'border-red-lp-750' : 'border-gray-lp-400'}`
    
    }, [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", {
          id: "attachment-name",
          class: ["text-gray-lp-300", _ctx.attachmentClassName]
        }, _toDisplayString(_ctx.shortNameFile(_ctx.name, _ctx.maxLength)), 3)
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.linked)
          ? (_openBlock(), _createBlock("a", {
              key: 0,
              href: _ctx.url,
              class: "text-red-lp-100 font-medium cursor-pointer",
              target: "_blank"
            }, " Download ", 8, ["href"]))
          : (_ctx.img)
            ? (_openBlock(), _createBlock("img", {
                key: 1,
                src: _imports_1,
                alt: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download(_ctx.url, _ctx.name)))
              }))
            : (_openBlock(), _createBlock("a", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.download(_ctx.url, _ctx.name))),
                target: "_blank",
                class: "text-red-lp-100 font-medium cursor-pointer"
              }, "Download"))
      ])
    ], 2),
    (_ctx.errorCaption)
      ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.errorCaption), 1))
      : _createCommentVNode("", true)
  ], 64))
}